module.exports = __webpack_public_path__ + "static/img/teambannerc.a969590.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teambannerc.jpg
// module id = +RFb
// module chunks = 1